





















































import { Component, Vue, Prop } from 'vue-property-decorator';
import Nullable from '@/types/nullable';
import Take5Details from './Take5Details.vue'
import Take5Think from './Take5Think.vue'
import Take5Manage from './Take5Manage.vue'
import Take5SafetyPrompt from './Take5SafetyPrompt.vue';
import Take5Controls from './Take5Controls.vue';
import EmailTake5Form from './EmailTake5Form.vue'
import * as JobsAPI from '@/api/jobsApi';
import { JobTake5Check } from '@/models/jobTake5/jobTake5Check';

@Component({
  components: {
    Take5Details,
    Take5Think,
    Take5Manage,
    Take5SafetyPrompt,
    Take5Controls,
    EmailTake5Form
  }
})
export default class JobTake5Form extends Vue {
  @Prop({ type: String, default: null }) public jobID!: string;
  @Prop({ type: Object, default: null }) public take5!: Nullable<JobTake5Check>;

  private showSendEmail: boolean = false;
  private errorMessage: string = null;
  private take5Valid: boolean = false;
  private saveLoading: boolean = false;
  
  created() {
    this.init();
  }
  
  async init(){
    // empty
  }

  goBack() {
    this.$router.go(-1);
  }

  async save() {
    this.saveLoading = true;

    try {
      // Validate before saving
      if(!this.valid()){
        return;
      }

      await JobsAPI.createOrUpdateTake5Form(this.take5);

      this.$emit('onDataChanged');
    } catch(err){
      this.errorMessage = err;
    }
    finally {
      this.saveLoading = false;
    }
  }

  async emailForm() {
    console.log('email')
    this.showSendEmail = true
  }
  
  valid() {
    let errors = [];
    this.errorMessage = null;

    if(this.take5.description === null){
      errors.push("DETAILS - Task description is required!");
    }

    if(
      this.take5.fit_for_task === null ||
      this.take5.authorised_to_complete === null ||
      this.take5.reviewed_procedures === null ||
      this.take5.required_training === null ||
      this.take5.tools_PPE === null ||
      this.take5.tools_PPE_condition === null ||
      this.take5.no_env_damage === null
    ){
      // THINK items must have non null values
      errors.push("THINK - Must select 'YES' or 'NO' for each item!");
    }

    let applicableHazards = this.take5.hazards.filter(h => h.applicable)
    let customHazardNull = false;
    let hazardManageNull = false;
    let hazardControlsNull = false;
    let hazardEffectiveNull = false;
    for(var i = 0; i < applicableHazards.length; i++){
      //hazard must have non null 'controllEffective' value
      let hazard = applicableHazards[i];
      console.log(hazard)

      if(hazard.allow_custom && (hazard.custom_hazard_name === null || hazard.custom_hazard_name.length == 0)){
        customHazardNull = true
      }
      if(hazard.managable === null){
        // the managability of applicable hazards must be set
        // the managability CAN BE FALSE, but it cannot be null
        hazardManageNull = true;
      }
      if (hazard.control_details === null || hazard.control_details.length == 0) {
        // the control for this hazard must be specified
        hazardControlsNull = true;
      }
      if (hazard.control_effective === null) {
        // the effectiveness for this control must be set
        // the effectiveness CAN BE FALSE, but it cannot be null
        hazardEffectiveNull = true;
      }
    }

    if(customHazardNull) {
      errors.push(`MANAGE - 'Other' hazards must have a description!`)
    }
    if(hazardManageNull) {
      errors.push(`MANAGE - Must select 'YES' or 'NO' for each applicable hazard`)
    }
    if(hazardControlsNull){
      errors.push(`CONTROLS - Each identified hazard must have a Control put in place!`)
    }
    if(hazardEffectiveNull){
      errors.push(`CONTROLS - Must select 'YES' or 'NO' for each implemented control!`)
    }

    if(this.take5.safety_prompt_1 === null || 
      this.take5.safety_prompt_2 === null || 
      this.take5.safety_prompt_3 === null
    ){
      errors.push(`SAFETY - Must select 'YES' or 'NO' for all Safety Prompts!`)
    }

    if(this.take5.safety_prompt_acknowledgement != true){
      errors.push(`SAFETY - Safety Prompt questions must be reviewed!`)
    }

    if (errors.length > 0){
      this.errorMessage = errors.join('\n');
      return false;
    }

    return true;
  }


}

